import { SelectOption } from 'info-ui-library';
import React, { useState, useEffect } from 'react';
import { themes } from '../theme/ThemeOptions';
import { useDispatch, useSelector } from 'react-redux';
import { getGridDataInSelectOption } from '../actions/index';
import { Row, Col } from '@bootstrap-styled/v4';


const GridComponent: React.FC<any> = (props: any) => {
    const dispatch = useDispatch();
    const handleSelectOptionGrid = (updatedValue, dbCode, type) => {
        props.handleSelectOption(updatedValue, dbCode, type, dispatch)
    }
    //fetch options from state
    const options = useSelector((state: any) => state.selectOptionDetails.gridSelectOption);

    useEffect(() => {
        dispatch(getGridDataInSelectOption())
    }, [])
    const valueAsAnObject = getValueObject(props.selectedValue, options);
    return (<SelectOption
        styleName={props.styleName}
        ioTheme={props.ioTheme}
        value={valueAsAnObject}
        ioMode={props.ioMode}
        options={options}
        label={props.label}
        configId={props.label}
        key={props.key}
        displayType={props.displayType}
        onChange={(value) => handleSelectOptionGrid(value, props.property.dbCode, "property")}
        isSearchable={true}
        isDisabled={false}
        isMulti={false}
        mandatory={props.mandatory}
        hasError='' />
    )
}

export default (GridComponent);
export const getValueObject = (initialvalue, selectedOptions) => {
    let value = null
    if (selectedOptions) {
        selectedOptions.map(object => {
            if (String(object.value) === String(initialvalue)) {
                value = object;
            }
            return null;
        })
    }
    return value
}